import Button from '@mui/material/Button';
import CardMedia from '@mui/material/CardMedia';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';

import AnimateButton from 'components/@extended/AnimateButton';
import MainCard from 'components/MainCard';

import avatar from 'assets/images/users/avatar-group.png';

export default function NavCard() {
  const navigate = useNavigate();

  return (
    <MainCard sx={{ bgcolor: 'grey.50', m: 3 }}>
      <Stack sx={{ gap: 2.5, alignItems: 'center' }}>
        <CardMedia component="img" image={avatar} sx={{ width: 112 }} />
        <Stack sx={{ alignItems: 'center' }}>
          <Typography variant="h5">ЯШЕН Pro</Typography>
          <Typography variant="h6" sx={{ color: 'secondary.main' }}>
            Купить Pro версию
          </Typography>
        </Stack>
        <AnimateButton>
          <Button variant="contained" color="success" size="small" onClick={() => navigate('/pro')}>
            Pro
          </Button>
        </AnimateButton>
      </Stack>
    </MainCard>
  );
}
